<template>
  <div>
    <PageTagline :elements="tagline_elem" />

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['tutorial_convenzioni_esperienze']"/>

    <!-- Pagina di login per il servizio -->
    <TsLoginPage :service_title="service_title" :service="service" :cluster="cluster" :comp_credito="comp_credito"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import TutorialContestuale from '@/components/TutorialContestuale'
import TsLoginPage from '@/components/tantosvago/TsLoginPage'

export default {
  name: 'TsExperience',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Esperienze", link : 'conv-attive' } ],

        // variabili che definiscono il servizio experiece con la quale
        // configuriamo la pagina di login.
        service_title: "Welcome To Italy",
        service: "welcometoitaly",
        cluster: "home",
        comp_credito: "totale"
    }
  },
  components: {
    PageTagline,
    TutorialContestuale,
    TsLoginPage
  }
}
</script>

<style scoped></style>